module.exports = __webpack_public_path__ + "img/pitches.7dfa1d00.svg";